/**
 * 基于axios的请求方法
 */

import axios from "axios"
import { baseUrl, NETWORK_ERR_MSG } from "../config"
 window.console.log(baseUrl)
// 使用这种类型必须对参数序列化，使用utils.queryString
// axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded"
 axios.defaults.baseURL =baseUrl;
export const http = axios.create({
    timeout: 7000, // 请求超时时间
    headers: {
        'Content-Type': 'application/json;charset=UTF-8'
    }
});
http.interceptors.request.use(config => {
window.console.log(config)
    return config
});
http.interceptors.response.use(response => {
   
    return response
  }, error => {
    return Promise.reject(error)
  })


export default http
